"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getFieldType_1 = __importDefault(require("../getValidationErrors/getError/getFieldType"));
const isNil_1 = __importDefault(require("lodash/isNil"));
const getObjectNode_1 = __importDefault(require("./getObjectNode"));
async function cleanType(type, fieldSchema, value, info, ...args) {
    info.type = fieldSchema.type;
    if (!info.type) {
        throw new Error('Cleaning field with no type');
    }
    const { clean: rootFieldClean } = await (0, getFieldType_1.default)(type);
    if (rootFieldClean && !(0, isNil_1.default)(value)) {
        value = await rootFieldClean(value, info, ...args);
    }
    let needReClean = false;
    const objectTypeSchema = (0, getObjectNode_1.default)(fieldSchema, value);
    if (objectTypeSchema && objectTypeSchema.type.__clean) {
        needReClean = true;
        value = await objectTypeSchema.type.__clean(value, info, ...args);
    }
    const { defaultValue } = fieldSchema;
    if ((0, isNil_1.default)(value) && !(0, isNil_1.default)(defaultValue)) {
        needReClean = true;
        if (typeof defaultValue === 'function') {
            value = await defaultValue(info, ...args);
        }
        else {
            value = defaultValue;
        }
    }
    const { autoValue } = fieldSchema;
    if (autoValue) {
        needReClean = true;
        value = await autoValue(value, info, ...args);
    }
    const { clean } = fieldSchema;
    if (clean) {
        needReClean = true;
        value = await clean(value, info, ...args);
    }
    if (needReClean && rootFieldClean && !(0, isNil_1.default)(value)) {
        value = await rootFieldClean(value, info, ...args);
    }
    return value;
}
exports.default = cleanType;
